module.exports = __webpack_public_path__ + "static/media/team.2348bbe0.png";